import { useTheme } from 'styled-components';
import { ThemeType } from 'styles/colorMode';

export { ThemeType };

export function useColorMode(): ThemeType {
    const { colorMode } = useTheme();
    return colorMode;
}
